import * as React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import history from '../../../../history';
import './MobileDropdown.css';
import { NavLink } from '../../../../models/nav';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider/Divider';
import ListItem from '@material-ui/core/ListItem/ListItem';
import withTheme, { WithTheme } from '@material-ui/core/styles/withTheme';
import * as styles from './MobileDropdown.css';

interface MobileDropdownProps {
  navLinks: NavLink[];
}

interface MobileDropdownState {
  anchorEl: Element | null;
  isOpen: boolean;
}

class MobileDropdown extends React.Component<MobileDropdownProps & WithTheme, MobileDropdownState> {
  constructor(props: any) {
    super(props);
    this.state = { anchorEl: null, isOpen: false };
  }

  public render() {
    const { anchorEl } = this.state;
    return (
      <>
        <IconButton
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={() => this.setState({ isOpen: true })}>
          <MenuIcon className={styles.MobileDropdownText} />
        </IconButton>
        <Drawer
          PaperProps={{ style: { backgroundColor: this.props.theme.palette.primary.main } }}
          anchor="right"
          open={this.state.isOpen}
          onClose={() => this.setState({ isOpen: false })}>
          <div
            tabIndex={0}
            role="button"
            onClick={() => this.setState({ isOpen: false })}
            onKeyDown={() => this.setState({ isOpen: false })}>
            {this.props.navLinks.map(linkData => (
              <div key={linkData.name}>
                {this.MobileNavLink(linkData)}
                <Divider />
              </div>
            ))}
          </div>
        </Drawer>
      </>
    );
  }

  private MobileNavLink({ name, icon, link, action }: NavLink) {
    return (
      <ListItem button onClick={link ? () => history.push(link) : () => action!()}>
        <ListItemIcon className={styles.MobileDropdownText}>{icon}</ListItemIcon>
        <ListItemText disableTypography className={styles.MobileDropdownText} primary={name} />
      </ListItem>
    );
  }
}

export default withTheme()(MobileDropdown);
